import axios from 'axios'

import env from '../../../config/env'
import { store } from '../../index'
import generateHeaderAuth from '../../../utils/generate-authorization-header'

const { uri: proxy } = env.server
const paperApiUri = `${proxy}/api/paper`

const fetchPapers = () => {
  return new Promise((resolve, reject) => {
    axios.get(`${paperApiUri}`)
      .then(response => resolve(response.data))
      .catch(err => {
        const defaultError = { message: 'Check your internet connection' }
        const { response = { } } = err
        const { data = defaultError } = response
        reject(data)
      })
  })
}

const createPaper = paper => {
  const { token } = store.getState().Auth
  return new Promise((resolve, reject) => {
    axios.post(`${paperApiUri}`, paper, generateHeaderAuth(token))
      .then(resolve)
      .catch(err => {
        const defaultError = { message: 'Check your internet connection' }
        const { response = { } } = err
        const { data = defaultError } = response
        reject(data)
      })
  })
}

const updatePaper = paper => {
  const { token } = store.getState().Auth
  const id = paper.get('_id')
  return new Promise((resolve, reject) => {
    axios.put(`${paperApiUri}/${id}`, paper, generateHeaderAuth(token))
      .then(resolve)
      .catch(err => {
        const defaultError = { message: 'Check your internet connection' }
        const { response = { } } = err
        const { data = defaultError } = response
        reject(data)
      })
  })
}

const deletePaper = id => {
  const { token } = store.getState().Auth
  return new Promise((resolve, reject) => {
    axios.delete(`${paperApiUri}/${id}`, { ...generateHeaderAuth(token) })
      .then(resolve)
      .catch(err => {
        const defaultError = { message: 'Check your internet connection' }
        const { response = { } } = err
        const { data = defaultError } = response
        reject(data)
      })
  })
}

export default { fetchPapers, createPaper, updatePaper, deletePaper }
